document.addEventListener("DOMContentLoaded", () => {
  const isDesktop = () => window.matchMedia("(min-width: 1100px)").matches;

  const headerWrapper = document.querySelector(".as-header-wrapper");
  const drawer = document.querySelector(".as-mob-drawer");

  let closeTimeout;
  let activeSubmenuItem = null;
  let isInsideMega = false;

  function activateFirstSubmenuItem(detailsEl) {
    const staticBlock = detailsEl.querySelector(".submenu-products--static");
    if (staticBlock) {
      staticBlock.hidden = false;
      return;
    }

    const firstItem = detailsEl.querySelector(".as-header__submenu-item");
    if (!firstItem) return;

    const handle = firstItem.dataset.handle;

    firstItem.classList.add("is-active");
    activeSubmenuItem = firstItem;

    document
      .querySelectorAll(".submenu-products:not(.submenu-products--static)")
      .forEach((p) => (p.hidden = true));

    const target = detailsEl.querySelector(
      `.submenu-products[data-handle="${handle}"]`,
    );
    if (target) target.hidden = false;
  }

  document.querySelectorAll(".as-header__submenu").forEach((submenu) => {
    submenu.addEventListener("mouseenter", () => {
      isInsideMega = true;
      clearTimeout(closeTimeout);
    });

    submenu.addEventListener("mouseleave", () => {
      isInsideMega = false;

      // ❗️Тут можна очистити active, АЛЕ З ЗАТРИМКОЮ
      closeTimeout = setTimeout(() => {
        if (!isInsideMega && activeSubmenuItem) {
          activeSubmenuItem.classList.remove("is-active");
          activeSubmenuItem = null;
        }
      }, 120);
    });
  });

  function closeAllMega(exceptEl) {
    document.querySelectorAll(".as-header__details").forEach((el) => {
      if (el !== exceptEl) el.setAttribute("aria-expanded", "false");
    });
  }

  document.querySelectorAll(".as-header__details").forEach((details) => {
    details.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;

      clearTimeout(closeTimeout);
      closeAllMega(details);
      details.setAttribute("aria-expanded", "true");
      headerWrapper?.classList.add("is-mega-open");

      // ✅ NEW: автоактивація першого пункту
      if (!activeSubmenuItem) {
        activateFirstSubmenuItem(details);
      }
    });

    details.addEventListener("mouseleave", () => {
      if (!isDesktop()) return;
      closeTimeout = setTimeout(() => {
        details.setAttribute("aria-expanded", "false");
        const anyOpen = document.querySelector(
          '.as-header__details[aria-expanded="true"]',
        );
        if (!anyOpen) headerWrapper?.classList.remove("is-mega-open");
      }, 120);
    });
  });

  document.querySelectorAll(".as-header__submenu-item").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      const handle = item.dataset.handle;

      if (activeSubmenuItem && activeSubmenuItem !== item) {
        activeSubmenuItem.classList.remove("is-active");
      }

      item.classList.add("is-active");
      activeSubmenuItem = item;

      document
        .querySelectorAll(".submenu-products:not(.submenu-products--static)")
        .forEach((p) => (p.hidden = true));

      const target = document.querySelector(
        `.submenu-products[data-handle="${handle}"]`,
      );
      if (target) target.hidden = false;
    });
  });

  let setActiveTab = () => {};

  document.querySelectorAll(".as-mob-header__burger").forEach((burger) => {
    burger.addEventListener("click", () => {
      const isOpen = headerWrapper.classList.contains(
        "as-header-wrapper--open",
      );
      headerWrapper.classList.toggle("as-header-wrapper--open");
      document.body.classList.toggle("as-fixed", !isOpen);
      if (!isOpen && drawer) setActiveTab("shop", true);
    });
  });

  if (drawer) {
    const backBtn = drawer.querySelector(".as-mob-back");
    const titleEl = drawer.querySelector(".as-mob-head-title");
    const headEl = drawer.querySelector(".as-mob-head");

    const stack = [{ level: 1, menuId: null, title: "" }];
    function render() {
      const state = stack[stack.length - 1];

      drawer.setAttribute("data-current-menu-level", state.level);
      drawer.setAttribute("data-current-menu-title", state.title || "");

      const isRoot = state.level === 1;
      headEl.style.display = isRoot ? "none" : "flex";
      backBtn.hidden = stack.length <= 1;

      // 🔥 нова логіка
      if (state.level === 2) {
        titleEl.innerHTML = `
      <span class="as-mob-head-title-main">
        ${(state.title || "").toUpperCase()}
      </span>
    `;
      } else if (state.level === 3) {
        const parent = stack[stack.length - 2];
        const parentTitle = (parent?.title || "").toUpperCase();
        const currentTitle = (state.title || "").toUpperCase();

        titleEl.innerHTML = `
      <span class="as-mob-head-title-main">${parentTitle}</span>
      <span class="as-mob-head-title-sep"> / </span>
      <span class="as-mob-head-title-sub">${currentTitle}</span>
    `;
      } else {
        titleEl.textContent = "Menu";
      }

      drawer
        .querySelectorAll(".as-mob-panel")
        .forEach((p) => (p.hidden = true));

      if (state.menuId) {
        const panel = drawer.querySelector(
          `.as-mob-panel[data-menu-id="${state.menuId}"]`,
        );
        if (panel) panel.hidden = false;
      }
    }

    function resetLevels() {
      stack.length = 1;
      render();
    }

    setActiveTab = (tab, reset = false) => {
      drawer.setAttribute("data-active-tab", tab);

      drawer.querySelectorAll(".as-mob-tab").forEach((b) => {
        b.classList.toggle("is-active", b.dataset.tab === tab);
      });

      drawer.querySelectorAll(".as-mob-tab-panel").forEach((p) => {
        p.classList.toggle("is-active", p.dataset.panel === tab);
      });

      const showLevels = tab === "shop";
      drawer.querySelectorAll(".as-mob-level").forEach((l) => {
        l.style.display = showLevels ? "" : "none";
      });

      if (reset || !showLevels) resetLevels();
      else render();
    };

    drawer.addEventListener("click", (e) => {
      const tabBtn = e.target.closest(".as-mob-tab");
      if (tabBtn) {
        setActiveTab(tabBtn.dataset.tab);
        return;
      }

      if (drawer.getAttribute("data-active-tab") !== "shop") return;

      const btn = e.target.closest("[data-next-level]");
      if (!btn) return;
      const currentList = btn.closest(".as-mob-list");

      if (currentList) {
        currentList.querySelectorAll("li").forEach((li) => {
          li.classList.remove("is-active-default");
        });

        btn.closest("li")?.classList.add("is-active-default");
      }
      stack.push({
        level: Number(btn.dataset.nextLevel),
        menuId: btn.dataset.menuId,
        title: btn.dataset.title || "",
      });

      render();
    });

    backBtn.addEventListener("click", () => {
      if (stack.length > 1) stack.pop();
      render();
    });

    setActiveTab("shop", true);
  }

  let lastScrollTop = 0;
  let headerHeight = headerWrapper?.offsetHeight || 0;

  window.addEventListener("resize", () => {
    headerHeight = headerWrapper?.offsetHeight || 0;
  });

  window.addEventListener("scroll", () => {
    if (!headerWrapper) return;
    if (headerWrapper.classList.contains("is-mega-open")) {
      headerWrapper.style.top = "0";
      return;
    }
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop < 100) {
      headerWrapper.style.top = "0";
      headerWrapper.classList.add("static");
      lastScrollTop = scrollTop;
      return;
    }
    headerWrapper.classList.remove("static");
    headerWrapper.style.top =
      scrollTop > lastScrollTop ? `-${headerHeight}px` : "0";
    lastScrollTop = scrollTop;
  });

  function syncHeaderOffset() {
    if (!headerWrapper) return;
    const h = headerWrapper.offsetHeight;
    document.documentElement.style.setProperty("--header-height", `${h}px`);
    document.body.style.paddingTop = `${h}px`;
  }

  window.addEventListener("load", syncHeaderOffset);
  window.addEventListener("resize", syncHeaderOffset);
});

function initMobileBannerSlider(scope = document) {
  const slider = scope.querySelector("[data-banner-slider]");
  if (!slider) return;

  const track = slider.querySelector("[data-banner-track]");
  const dotsWrap = slider.querySelector("[data-banner-dots]");
  if (!track || !dotsWrap) return;

  const slides = [...track.querySelectorAll(".as-mob-banner--small")];
  if (slides.length <= 1) return;

  dotsWrap.innerHTML = slides.map(() => "<span></span>").join("");
  const dots = [...dotsWrap.children];

  const setActive = (i) => {
    dots.forEach((d) => d.classList.remove("is-active"));
    dots[i]?.classList.add("is-active");
  };

  setActive(0);

  let raf = null;
  track.addEventListener("scroll", () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      let best = 0;
      let dist = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - track.scrollLeft);
        if (d < dist) {
          dist = d;
          best = i;
        }
      });
      setActive(best);
    });
  });

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
    });
  });
}

document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".as-header-product-card__add");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: +variantId,
            quantity: 1,
          },
        ],
      }),
    });

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:open"));
  } catch (err) {
    console.error("Add to cart error:", err);
  }
});

document.addEventListener(
  "click",
  (event) => {
    const toggle = event.target.closest(".as-mobile-search-toggle");
    const header = document.querySelector(".as-header-wrapper");
    const closeSearch = document.querySelector("[data-close-search]");

    if (!toggle || !header) return;

    if (header.classList.contains("is-search-open")) {
      event.preventDefault();
      event.stopPropagation();

      if (closeSearch) closeSearch.click();
      header.classList.remove("is-search-open");
      document.body.classList.remove("as-search-open");
      return;
    }

    setTimeout(() => {
      header.classList.add("is-search-open");
      document.body.classList.add("as-search-open");
    }, 50);
  },
  true,
);

document.addEventListener("click", (event) => {
  if (event.target.closest("[data-close-search]")) {
    document
      .querySelector(".as-header-wrapper")
      ?.classList.remove("is-search-open");
    document.body.classList.remove("as-search-open");
  }
});
